export default function Backlight({ backlight }) {
  return backlight && <div className={'button__backlight'} />;
}
